import React from 'react';
import TestAccordion from "../TestAccordion/testAccordion";

/**
 * Test list tab with accordian.
 * @param props
 * @returns {*}
 * @constructor
 */
const TestListTab = props => {
    const { quizGroups, lang, singleTestSeriesLoading } = props;
    return (
        <React.Fragment>
            {
                quizGroups && quizGroups.length ?
                    quizGroups.map((data, index) => {
                        return (
                            <TestAccordion quizGroup={data} key={data._id} lang={lang}
                                           singleTestSeriesLoading={singleTestSeriesLoading}/>
                        );
                    }) : <TestAccordion singleTestSeriesLoading={singleTestSeriesLoading}/>
            }
        </React.Fragment>
    );
};
export default TestListTab;
